"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PreviewCigarette = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _search = require("../../../../constants/search");
var _rebrand = require("../../../../icons-react/rebrand");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var DEFAULT_PLACEHOLDER = 'Страна, город или отель';
var PreviewCigarette = exports.PreviewCigarette = function PreviewCigarette(_ref) {
  var destinationName = _ref.destinationName,
    startDate = _ref.startDate,
    endDate = _ref.endDate,
    personsCount = _ref.personsCount,
    onClick = _ref.onClick,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
    className = _ref.className,
    searchType = _ref.searchType;
  var viewCondition = (0, _react.useMemo)(function () {
    return destinationName && startDate && endDate && personsCount;
  }, [destinationName, startDate, endDate, personsCount]);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    onClick: onClick,
    $isMobile: isMobile,
    className: className,
    $searchType: searchType,
    $firstTabOpen: searchType === _search.SEARCH_TYPE_NAMES.PACKAGE
  }, !isMobile && /*#__PURE__*/_react["default"].createElement(SearchIcon, null), !viewCondition && /*#__PURE__*/_react["default"].createElement(Item, null, DEFAULT_PLACEHOLDER), viewCondition && /*#__PURE__*/_react["default"].createElement(ItemsList, {
    $isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(Row, {
    $isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(Item, null, destinationName)), /*#__PURE__*/_react["default"].createElement(Row, {
    $isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(Item, null, /*#__PURE__*/_react["default"].createElement("span", null, startDate), "\u2013", /*#__PURE__*/_react["default"].createElement("span", null, endDate)), /*#__PURE__*/_react["default"].createElement(Item, null, /*#__PURE__*/_react["default"].createElement("span", null, personsCount, " \u0447\u0435\u043B")))));
};
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "PreviewCigarette__Wrapper",
  componentId: "sc-6484sw-0"
})(["display:flex;flex:1;align-items:center;padding:11px 8px;background-color:var(--white);border-radius:var(--border-radius);color:var(--black);font-size:12px;font-style:normal;font-weight:500;cursor:pointer;", ""], function (_ref2) {
  var $isMobile = _ref2.$isMobile;
  return $isMobile && (0, _styledComponents.css)(["flex-wrap:wrap;height:40px;padding:4px;justify-content:center;gap:0 8px;overflow:hidden;& > ", ":first-child{flex:0 1 100%;}"], Item);
});
var Row = _styledComponents["default"].div.withConfig({
  displayName: "PreviewCigarette__Row",
  componentId: "sc-6484sw-1"
})(["display:flex;& > * + *{margin-left:", "px;}", ""], function (_ref3) {
  var $isMobile = _ref3.$isMobile;
  return $isMobile ? '8' : '16';
}, function (_ref4) {
  var $isMobile = _ref4.$isMobile;
  return $isMobile && 'justify-content: center;';
});
var Item = _styledComponents["default"].div.withConfig({
  displayName: "PreviewCigarette__Item",
  componentId: "sc-6484sw-2"
})(["display:flex;gap:4px;justify-content:center;"]);
var ItemsList = _styledComponents["default"].div.withConfig({
  displayName: "PreviewCigarette__ItemsList",
  componentId: "sc-6484sw-3"
})(["display:flex;", ";", ""], function (_ref5) {
  var $isMobile = _ref5.$isMobile;
  return !$isMobile && (0, _styledComponents.css)(["> * + *{margin-left:16px;}"]);
}, function (_ref6) {
  var $isMobile = _ref6.$isMobile;
  return $isMobile && "flex-direction: column;";
});
var SearchIcon = (0, _styledComponents["default"])(_rebrand.Search).withConfig({
  displayName: "PreviewCigarette__SearchIcon",
  componentId: "sc-6484sw-4"
})(["height:16px;margin-right:6px;"]);